import { useStaticQuery, graphql } from 'gatsby'
import { BLOGS } from "../../lib/collectionNames";
import makeSlugForContentfulPost from "../../lib/makeSlugForContentfulPost";

export const useBlogs = () => {
  const data = useStaticQuery(graphql`
    query {
      allData: allResource(
        filter: { collection: { eq: "blogs" } }
        sort: { order: DESC, fields: publishedDate }
      ) {
        nodes {
          id
          slug
          publishedDate(formatString: "MMMM D YYYY")
          data {
            title
            thumbnail
            abstract
          }
        }
      }
      allContentfulBlog: allContentfulBlog(
        sort: { order: DESC, fields: publishedDate },
        filter: { title: { ne: "Dummy" } }
      ) {
          nodes {
            id
            slug
            publishedDate(formatString: "MMMM D YYYY")
            heading
            subHeading
            thumbnailImage {
              url
            }
            thumbnail{
              file{
                url
              }
            }
          }
      }
    }
  `)

  const { allData: localJSONData, allContentfulBlog: allContentfulData } = data;

  const localJSONCards = localJSONData.nodes.map(resource => ({
    id: resource.id,
    slug: `${resource.slug}/`,
    thumbnail: resource.data.thumbnail,
    publishedDate: resource.publishedDate,
    title: resource.data.title,
    abstract: resource.data.abstract,
  }))

  const contentfulCards = allContentfulData.nodes.map(resource => {
    const slug = makeSlugForContentfulPost(resource, BLOGS);

    return ({
      id: resource.id,
      slug: `${slug}/`,
      thumbnail: resource.thumbnailImage ? resource.thumbnailImage[0].url : "https:" + resource.thumbnail.file.url,
      publishedDate: resource.publishedDate,
      title: resource.heading,
      abstract: resource.subHeading,
    });
  })

  const allCards = [...contentfulCards, ...localJSONCards];

  return allCards;
}

export default useBlogs
